/**
 * @author Artem Lytvynov
 * @copyright Artem Lytvynov
 * @license Apache-2.0
 */

export enum FIELD_TYPE_VALUES {
  INT8 = "int-8",
  INT16 = "int-16",
  INT32 = "int-32",
  INT64 = "int-64",
  FLOAT32 = "float-32",
  FLOAT64 = "float-64",
  BINARY = "binary",
  UTF8 = "utf-8",
  DECIMAL = "decimal",
  DATE = "date",
  TIME = "time",
  TIMESTAMP = "timestamp",
}
